import React from 'react';
import { useTranslation } from 'react-i18next';

import { useDeleteChat } from '@/modules/AiAgents/apiHooks';
import { Button, Typography } from '@/shared/components/atoms';
import { useStore } from '@/shared/hooks/context/createGenericContext';
import { useModal } from '@/shared/hooks/context/modalContext/useModal';

import TriangleExleminationMark from '~/images/shared/TriangleExleminationMark.svg';

const RessetDataModal: React.FC<{ handleResetData: () => void }> = ({
  handleResetData,
}) => {
  const { t } = useTranslation('common');
  const { closeModal } = useModal();
  const [selectedAsset] = useStore((store) => store?.asset);
  const { mutate } = useDeleteChat();

  const handleReset = () => {
    if (selectedAsset) {
      closeModal();
      mutate(selectedAsset.id);
      handleResetData();
    }
  };

  return (
    <div className='flex w-full flex-col items-center justify-center gap-16'>
      <span className='w-fit text-48 text-error-400'>
        <TriangleExleminationMark />
      </span>
      <div className='text-center'>
        <Typography variant='h6' weight='semiBold'>
          {t('resetting-data')}
        </Typography>
        <Typography variant='caption' className='text-surface-10'>
          {t('reset-data-description')}
        </Typography>
      </div>
      <div className='flex w-full items-center justify-end gap-8'>
        <Button
          type='button'
          variant='text'
          size='md'
          onClick={() => closeModal()}
        >
          {t('cancel')}
        </Button>
        <Button
          type='button'
          color='red'
          variant='filled'
          size='md'
          onClick={handleReset}
        >
          {t('yes-reset')}
        </Button>
      </div>
    </div>
  );
};

export { RessetDataModal };
